export default __webpack_public_path__ + "static/phone-tasks-3cb21f21f01ed9f49e6c0081d8b1c789.png";